const fileFromUrl = url => url.split('/').pop().split('#')[0].split('?')[0];

export { fileFromUrl };



// WEBPACK FOOTER //
// ./client/src/libs/url.js